// services/jira.service.ts
import { HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { JiraTicket } from '../models/jira-ticket';
import { ApiService } from './api.service';


export interface UploadEvent {
  type: 'complete';
  body: any;
}

@Injectable({
  providedIn: 'root'
})
export class JiraService extends ApiService {
  apiName = 'core';

  getOpenTickets(robotName: string): Observable<JiraTicket[]> {
    return this.http.get<any[]>(this.url('jira/open_tickets'), {
      params: { robot_name: robotName }
    }).pipe(
      map(response => response.map(ticket => new JiraTicket().deserialize(ticket)))
    );
  }

  getCreateMeta(workType: string): Observable<any> {
    return this.http.get<any>(this.url('jira/create_meta'), {
      params: {
        work_type: workType
      }
    });
  }

  createTicket(payload: any): Observable<JiraTicket> {
    return this.http.post<any>(this.url('jira/create_ticket'), payload).pipe(
      map(response => new JiraTicket().deserialize(response))
    );
  }

  uploadAttachments(issueKey: string, files: File[]) {
    const formData = new FormData();
    formData.append('issue_key', issueKey);
    files.forEach(file => formData.append('files[]', file, file.name));

    return this.http.post<any>(this.url('jira/attachments'), formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      filter(event => event.type === HttpEventType.Response),
      map(event => ({ type: 'complete', body: event.body }) as UploadEvent)
    );
  }
}
